/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BillieInteractionDto } from '../models/BillieInteractionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BillieResourceService {
    /**
     * @param applicationNumber
     * @returns BillieInteractionDto OK
     * @throws ApiError
     */
    public static getBillieInteractionsByApplicationNumber(
        applicationNumber: string,
    ): CancelablePromise<Array<BillieInteractionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/billie/interactions/{applicationNumber}',
            path: {
                'applicationNumber': applicationNumber,
            },
        });
    }
}
